import Button, { ButtonProps } from 'react-bootstrap/Button';
import React, { FC, ReactElement } from 'react';

const PrimaryButton: FC<ButtonProps> = ({ className, ...props }: ButtonProps): ReactElement => {
  return <Button variant="primary" className={`text-white ${className} ?? ''`} {...props} />;
};

export default PrimaryButton;
